<template>
    <v-container class="px-0 mobileDropDown" data-testid="custom-dropdown-mobile">
        <label
            :aria-label="formattedAriaLabelForSelectBoxWithDescription(
                label,
                required,
                getConfig.multiple
            )"
            tabindex="0"
            aria-hidden="false"
            :for="id">
            {{ formattedLabel(label, required) }}
        </label>
        <select
            v-model="value"
            :aria-label="formattedAriaLabelForSelectBox(
                label,
                required,
                getTextValue
            )"
            tabindex="0"
            :multiple="getConfig.multiple"
            :required="required"
            aria-hidden="false"
            :name="id"
            :class="`${!getConfig.multiple ? 'minimal' : ''} ${displayHasRequired ? 'required' : ''}`"
            :id="id"
            @change="(e) => getConfig.multiple ? selectMultiple(e.target.options) : selectChange(e.target.value)"
            @blur="(e) => checkRequiredField()">
            <option
                v-for="(option) in options"
                :value="option.value"
                v-bind:key="option.id"
                @keydown.enter="(e) => selectChange(e.target.value)"
                @click="(e) => selectChange(e.target.value)">
                {{ option.text }}
            </option>
        </select>
        <div v-if="displayHasRequired" class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
                <div tabindex="0" aria-hidden="false" class="v-messages__message">
                    {{ $t('base.errors.requiredFieldWithLabel', {fieldLabel: getFieldName}) }}
                </div>
            </div>
        </div>
    </v-container>
</template>
<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { formRules } from '@/mixins/form-rules';
import { customDropdown } from './customDropdown';

export default {
    props: {
        index: { type: Number, required: true },
        id: { type: String, required: true },
        options: { type: { value: String | Boolean | Number, text: String }, required: true },
        label: { type: String, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: null },
    },
    data() {
        return {
            displayHasRequired: false
        };
    },
    mixins: [formRules, inputHelpers, customDropdown]
};
</script>
<style scoped lang="scss">
.mobileDropDown {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    padding: 0;
    margin: 0;
}
.mobileDropDown label {
    padding: 10px 0;
    display: block;
}
select{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    border: 1px solid gray;
    border-radius: 5px;
    min-height: 50px;
    display: block;
    padding: 0 10px 0 10px;
    margin: 0 0 10px 0;

    &.minimal {
        background-image:
            linear-gradient(45deg, transparent 50%, gray 50%),
            linear-gradient(135deg, gray 50%, transparent 50%);
        background-position:
            calc(100% - 20px) calc(1em + 4px),
            calc(100% - 15px) calc(1em + 4px);
        background-size:
            5px 5px,
            5px 5px,
            1px 1.5em;
        background-repeat: no-repeat;
    }

    &.minimal:focus {
        background-image:
            linear-gradient(45deg, #00ccf2 50%, transparent 50%),
            linear-gradient(135deg, transparent 50%, #00ccf2 50%);
        background-position:
            calc(100% - 15px) 1.2em,
            calc(100% - 20px) 1.2em;
        background-size:
            5px 5px,
            5px 5px,
            1px 1.5em;
        background-repeat: no-repeat;
        border-color: #00ccf2;
        outline: 0;
    }

    &.minimal.required {
        background-image:
            linear-gradient(45deg, transparent 50%, red 50%),
            linear-gradient(135deg, red 50%, transparent 50%);
    }

    &.minimal.required:focus {
        background-image:
            linear-gradient(45deg, red 50%, transparent 50%),
            linear-gradient(135deg, transparent 50%, red 50%);
    }

    &.required {
        color: red;
        border: 1px solid red;
    }
}
</style>
